<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="name" >
        <el-input v-model="queryParams.name" placeholder="公众号名称"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item prop="appId">
        <el-input v-model="queryParams.appId" placeholder="APPID"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="type">
        <el-select v-model="queryParams.type" filterable clearable  placeholder="类型" >
          <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" size="medium" icon="el-icon-plus" @click.native="add">新增</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-top: 10px">
      <el-table :data="tableData" border>
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="name" label="公众号名称" align="center"></el-table-column>
        <el-table-column prop="appId" label="APPID" align="center"></el-table-column>
        <el-table-column prop="username" label="创建人" align="center"></el-table-column>
        <el-table-column prop="secret" label="秘钥" align="center"></el-table-column>
        <el-table-column prop="token" label="公众号Token" align="center"></el-table-column>
        <el-table-column prop="channel" label="通道" align="center"></el-table-column>
        <el-table-column prop="status" label="类型" :formatter="typeFormat" align="center"></el-table-column>
        <el-table-column prop="url" label="回调url" align="center"></el-table-column>
        <el-table-column label="操作" width="230" align="center">
          <template slot-scope="scope">
            <el-button size="mini"  type="primary" plain icon="el-icon-edit" @click="updateRow(scope.row)" >编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="600px" append-to-body v-dialogDrag :close-on-click-modal="false">
      <el-form :model="form" label-width="80px" ref="form" :rules="rules">
        <el-form-item label="公众号名称:" prop="name" label-width="100px">
          <el-input v-model="form.name" autocomplete="off" style="width: 85%" placeholder="请输入公众号名称"></el-input>
        </el-form-item>
        <el-form-item label="APPID:" prop="appId" label-width="100px">
          <el-input v-model="form.appId" :disabled="disable" autocomplete="off" style="width: 85%" placeholder="请输入APPID"></el-input>
        </el-form-item>
        <el-form-item label="秘钥:" prop="secret" label-width="100px">
          <el-input v-model="form.secret" autocomplete="off" style="width: 85%" placeholder="请输入秘钥"></el-input>
        </el-form-item>
        <el-form-item label="Token:" prop="token" label-width="100px">
          <el-input v-model="form.token" autocomplete="off" style="width: 85%" placeholder="请输入Token"></el-input>
        </el-form-item>
        <el-form-item label="消息秘钥:" prop="aesKey" label-width="100px">
          <el-input v-model="form.aesKey" autocomplete="off" style="width: 85%" placeholder="请输入消息秘钥"></el-input>
        </el-form-item>
        <el-form-item label="编码:" prop="channel" label-width="100px">
          <el-input v-model="form.channel" autocomplete="off" style="width: 85%" placeholder="请输入编码"></el-input>
        </el-form-item>
        <el-form-item label="URL:" prop="url" label-width="100px">
          <el-input v-model="form.url" autocomplete="off" style="width: 85%" placeholder="回调url"></el-input>
        </el-form-item>
        <el-form-item label="支付账号:" prop="mchIds" label-width="100px">
          <el-select v-model="form.mchIds" multiple @change='changeMch'  placeholder="请选择支付账号" style="width: 85%">
            <el-option v-for="item in mchNames" :key="item.mchId" :label="item.mchName" :value="item.mchId" ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog()">取消</el-button>
        <el-button type="success" @click="submitForm()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { wechatPage } from "@/api/api.js"; //平台分页列表
import { payConfigList } from "@/api/api.js"; 
import { saveOrUpdateWxAndPay } from "@/api/api.js";
import { mchIdByAppId } from "@/api/api.js";
export default {
  name:'wechatIndex',
  data() {
    return{
      queryParams:{
        name:undefined,
        appId:undefined,
        type:undefined
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      title:"",
      method:'add',
      dialog:false,
      mchNames:[],
      form:{},
      disable:false,
      rules:{
        name:[
          { required: true, message: "请输入公众号名称", trigger: "blur" }
        ],
        appId:[
          { required: true, message: "请输入APPID", trigger: "blur" }
        ],
        secret:[
          { required: true, message: "请输入公众号秘钥", trigger: "blur" }
        ],
        url:[
          { required: true, message: "请输入URL", trigger: "blur" }
        ]
      },
      type: [
        { value: 1, label: "内部" },
        { value: 2, label: "对外" }
      ],
    }
  },
  methods: {
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    // 获取列表的数据
    initData(){
      let params= {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      wechatPage(params).then(res=>{
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData.map((item,index)=>{
            item.ids = index + 1
          })
        }
      })
    },
    // 弹窗的x
    dialogClose(){
      this.$refs.form.clearValidate();
      this.dialog = false;
    },
    // 弹窗的取消
    cancelDialog(){
      this.dialog = false;
    },
    //提交表单
    submitForm(){
        this.$refs.form.validate(valid => {
        if (valid) {
            let params ={
              ...this.form
            }
            saveOrUpdateWxAndPay(params).then(res=>{
              if(res.data.code == 200){
                this.$notify({
                  title: '成功',
                  message: '公众号配置成功',
                  type: 'success'
                });
                this.dialog = false;
                this.initData();
              }
            })
        }
      });
    },
    // 编辑
    updateRow(row){
        this.disable = true;
        let flag = row.flag;
        let userId = row.userId;
        let appId = row.appId;
        this.dialog = true;
        if(flag=='2'){
          //代理商
          this.$router.push('/platformSetting/userSetting/' + userId);
        }else{
          this.title = "编辑公众号";
          mchIdByAppId({
            appId : appId
          }).then(res=>{
            this.form = row;
            if(res.data.code == 200){
              this.form.mchIds = res.data.data;
            }
          });
          
        }
    },
    add(){
      this.title = "新增系统公众号";
      this.dialog = true;
      this.disable = false;
      this.form = {};
    },
    changeMch(){
        this.$forceUpdate();
    },
    payConfigList(){
      payConfigList().then(res=>{
          if (res.data.code == 200) {
              let data = res.data.data;
              this.mchNames =data; 
          }
      });
    },
    typeFormat(row){
      return row.type=='1' ? '内部' : '对外';
    }
  },
  mounted() {
    this.initData();
    this.payConfigList();
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">

</style>


